<template>
    <div class="DontGetAnswer-Wrap">
        <div class="DontGetAnswer-WrapHeadline">
            <div class="DontGetAnswer-Wrap-HeadlineWrap">
                <h2>{{translation.title}}</h2>
            </div>
        </div>
        <div class="form-error" v-if="error">
            <b>{{translation.error_title}}</b>
            <br>{{translation.error_text}}
        </div>
        <div class="form-success" v-if="success">
            <b>{{translation.success_title}}</b>
            <br>{{translation.success_text}}
        </div>
        <div class="DontGetAnswerWrapForm" v-if="!error">
            <form @submit.prevent="submit" novalidate="true" v-if="!success && !error" class="DontGetAnswer__form">
                <div class="columns is-multiline">
                    <div class="column is-half">
                        <input type="text" id="name" name="name" v-model="name" v-validate="'required'" :data-vv-as="translation.name"
                               :placeholder="translation.name +  '*'">
                        <span>{{ errors.first('name') }}</span>
                    </div>
                    <div class="column is-half">
                        <input type="email" id="email" name="email" v-model="email" v-validate="'required|email'" :data-vv-as="translation.email"
                               :placeholder="translation.email +  '*'">
                        <span>{{ errors.first('email') }}</span>
                    </div>
                    <div class="column is-full">
                        <textarea :placeholder="translation.question +  '*'" v-model="message" id="message" name="message"
                                  v-validate="'required'" :data-vv-as="translation.question" cols="30" rows="5"></textarea>
                        <span>{{ errors.first('message') }}</span>
                    </div>
                    <div class="column is-full">
                        <div class="DontGetAnswer__form-buttonWrap">
                            <div class="loader" v-if="loading"></div>
                            <button class="button " type="submit" v-else>{{translation.submit}}</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import es from 'vee-validate/dist/locale/es';
    import fr from 'vee-validate/dist/locale/fr';
    import de from 'vee-validate/dist/locale/de';
    import en from 'vee-validate/dist/locale/en';

    export default {
        props: {
            translation: Object,
			contactUrl: String
        },
        data: function () {
            return {
                name: null,
                email: null,
                message: null,
                success: false,
                error: false,
                loading: false
            }
        },
        mounted() {
            let messages = []
            messages['en'] = en.messages
            messages['es'] = es.messages
            messages['de'] = de.messages
            messages['fr'] = fr.messages

            this.$validator.localize(this.translation.locale, {
                messages: messages[this.translation.locale]
            })
        },
        methods: {
            submit: function () {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.loading = true;
                        axios
                            .post(this.contactUrl, {
                                name: this.name,
                                email: this.email,
                                message: this.message,
                                language: this.translation.locale
                            })
                            .then(response => {
                                this.success = true;
                            })
                            .catch(error => {
                                this.error = true;
                            })
                            .finally(() => {
                                this.loading = false;
                            })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
